const React = require('react');
const noop = require('mn-utils/noop');
const CheckboxB = require('./B');


module.exports = (props) => {
  const {
    label,
    checked,
  } = props;

  const disabled = props.disabled || false;
  return (
    <div className={'layoutRow fhaS fvaS mh-5 ' + (props.className || '')}>
      <CheckboxB
        className="c575960"
        error={props.error}
        black={props.black}
        onChange={props.onChange || noop}
        checked={checked}
        disabled={disabled}
      />
      {
        label ? (
          <div
            className="ml15 pt8 f15 lh160% ff$2 usN"
          >{label}</div>
        ) : null
      }
    </div>
  );
};
